import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { refreshRoles } from 'src/reducers/roles.reducer';
import axios, { AxiosResponse } from 'axios';
import { Capability } from 'src/models/user.model';

type InitialState = {
  loading: boolean;
  failure: boolean;
  success: boolean;
  capabilities: Capability[];
};

const INITIAL_STATE: InitialState = {
  loading: false,
  failure: false,
  success: false,
  capabilities: [] as Capability[],
};

export const changeCapabilitiesForRole = createAsyncThunk(
  'capabilities/put',
  async (params: { roleId: number; capabilityId: number }, { rejectWithValue, dispatch }) => {
    try {
      const response: AxiosResponse<Capability[]> = await axios.put(`/api/capabilities`, params);
      dispatch(refreshRoles());
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const changeCapabilitySlice = createSlice({
  name: 'capabilities',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(changeCapabilitiesForRole.pending, (state: InitialState) => {
      return {
        ...state,
        loading: true,
        failure: false,
        success: false,
      };
    });

    builder.addCase(changeCapabilitiesForRole.fulfilled, (state: InitialState, action: PayloadAction<Capability[]>) => {
      return {
        ...state,
        loading: false,
        failure: false,
        success: true,
        capabilities: action.payload,
      };
    });

    builder.addCase(changeCapabilitiesForRole.rejected, (state: InitialState) => {
      return {
        ...state,
        loading: false,
        failure: true,
        success: false,
      };
    });
  },
});

export default changeCapabilitySlice.reducer;
